import { render, staticRenderFns } from "./member-batch-add.vue?vue&type=template&id=336f844a&scoped=true";
import script from "./member-batch-add.vue?vue&type=script&lang=jsx";
export * from "./member-batch-add.vue?vue&type=script&lang=jsx";
import style0 from "./member-batch-add.vue?vue&type=style&index=0&id=336f844a&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "336f844a", null);
export default component.exports;